/**
 * Get the appropriate Google Maps API key based on environment
 * @returns {string | undefined} The Google Maps API key
 */
export function getMapApiKey() {
    return import.meta.env.DEV
        ? import.meta.env.VITE_GOOGLE_MAPS_API_KEY_LOCAL ?? import.meta.env.VITE_GOOGLE_MAPS_API_KEY
        : import.meta.env.VITE_GOOGLE_MAPS_API_KEY_PROD ?? import.meta.env.VITE_GOOGLE_MAPS_API_KEY
}
